<script setup>
import { ref, computed } from 'vue';
import WhatsAppTemplateParser from 'dashboard/components-next/whatsapp/WhatsAppTemplateParser.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import TagMultiSelectComboBox from 'dashboard/components-next/combobox/TagMultiSelectComboBox.vue';
import { useMapGetter } from 'dashboard/composables/store';

defineProps({
  template: {
    type: Object,
    default: () => ({}),
  },
  sendRenderedContent: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['sendMessage', 'resetTemplate']);

// M-47: labels added to the conversation alongside the template, so an automation rule can act on it (e.g. close it).
const selectedLabels = ref([]);
const labels = useMapGetter('labels/getLabels');
const labelOptions = computed(() =>
  labels.value.map(({ title }) => ({ value: title, label: title }))
);

const handleSendMessage = payload => {
  emit('sendMessage', { ...payload, labels: selectedLabels.value });
};

const handleResetTemplate = () => {
  emit('resetTemplate');
};
</script>

<template>
  <div class="w-full">
    <WhatsAppTemplateParser
      :template="template"
      :send-rendered-content="sendRenderedContent"
      @send-message="handleSendMessage"
      @reset-template="handleResetTemplate"
    >
      <template #actions="{ sendMessage, resetTemplate, disabled }">
        <TagMultiSelectComboBox
          v-model="selectedLabels"
          :options="labelOptions"
          :placeholder="$t('WHATSAPP_TEMPLATES.PARSER.LABELS_PLACEHOLDER')"
          :search-placeholder="$t('WHATSAPP_TEMPLATES.PARSER.LABELS_SEARCH')"
          :empty-state="$t('WHATSAPP_TEMPLATES.PARSER.LABELS_EMPTY')"
          class="w-full mb-4"
        />
        <footer class="flex gap-2 justify-end">
          <NextButton
            faded
            slate
            type="reset"
            :label="$t('WHATSAPP_TEMPLATES.PARSER.GO_BACK_LABEL')"
            @click="resetTemplate"
          />
          <NextButton
            type="button"
            :label="$t('WHATSAPP_TEMPLATES.PARSER.SEND_MESSAGE_LABEL')"
            :disabled="disabled"
            @click="sendMessage"
          />
        </footer>
      </template>
    </WhatsAppTemplateParser>
  </div>
</template>
